import React from "react";
import { Form, DatePicker, TimePicker, Popover, Icon } from "antd";
import moment from "moment";

const SurchargePaymentDate = ({ form, disabled }) => {
  const { getFieldDecorator } = form;

  const popover = (
    <div className="popover-content">
      <p>
        Срок оплаты дополнительных платежей (фактического использования ТС при
        отклонении от маршрута или в случае превышения расчётного времени
        использования ТС в связи с действиями организатора или пассажиров,
        компенсации дополнительных расходов фрахтовщика) (С2)
      </p>
    </div>
  );

  const initialValue =
    form.getFieldValue("arrivalDatetime") &&
    form.getFieldValue("arrivalDatetime").format();
  return (
    <div className="offer-card__item">
      <span className="label">
        Срок оплаты доп.
        <br /> платежей (С2):
      </span>
      <Form.Item>
        {getFieldDecorator("surchargePaymentDate", {
          rules: [
            {
              required: true,
              message: "Поле, обязательное для заполнения"
            }
          ],
          initialValue: moment(initialValue)
        })(
          <DatePicker
            style={{ width: 128 }}
            format="DD.MM.YYYY"
            placeholder="ДД.ММ.ГГГГ"
            disabled={disabled}
            disabledDate={current =>
              current < form.getFieldValue("arrivalDatetime")
            }
          />
        )}
      </Form.Item>
      <Form.Item>
        {getFieldDecorator("surchargePaymentDate", {
          initialValue: moment(initialValue).add(5, "hours")
        })(
          <TimePicker
            style={{ width: 128 }}
            defaultOpenValue={moment("00:00", "HH:mm")}
            placeholder="Время"
            format="HH:mm"
            disabled={disabled}
          />
        )}
      </Form.Item>
      <span className="extra-label additional-input">
        <span className="show-map">
          <Popover
            overlayClassName="order-popover"
            placement="topLeft"
            content={popover}
            trigger="click"
          >
            <Icon type="question-circle" />
          </Popover>
        </span>
      </span>
    </div>
  );
};

export default SurchargePaymentDate;
